import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import SliderWrapper from 'jd-library/SliderWrapper';
import OtpVerification from 'jd-library/OtpVerification';
import historyHandler from 'jd-library/historyHandler';
import { connect } from 'react-redux';
import styles from './verify_user.scss';
import {setSession, setLoggedUser} from '../../actions/index';
import {clickTrack, toggleTab} from '../../actions/products';
import {useHistory} from 'react-router-dom';

const VerifyUser = props => {
	let {heading,onHidden,mobOrEmail,isEmail,sendOtpApi,verifyOtpApi,failedCount,fromDiscount,fromInventory,fromOrderListing,headersData} = props;
	const isMobile = props.isMobile;
	let history = useHistory();
	const [header, setHeader] = useState(failedCount ? {
		heading: heading,
		leftIcons: [],
		rightIcons: [{
			className: 'icon-HDRcross',
			onClick: e => {historyHandler.closeCurrent();}
		}],
		variant: 'secondary'
	} : {
		heading: heading,
		leftIcons: [{
			className: 'icon-hdrBackNew',
			onClick: e => {historyHandler.closeCurrent();}
		}],
		rightIcons: [],
		variant: 'secondary'
	});
	const onSend = (data) => {
		return({
			errors: {
				code: 0
			},
			results:{
				sent: data.isSuccess
			}
		});
	}
    const onVerify = (data) => {
		if(data.isSuccess){
			if (props.session.source != 'webstore' && !data.prodCrudData?.subType) {
				let apiUrl = '/marketplace/static/php/web/b2bWebsite.php?&action=getCompanyDetails&token=' + props.session.token + '&platform='+(props?.platform ? props?.platform : '');
				axios.get(apiUrl).then(result => {
					if(result.data.status) {
						props.setLoggedUser(data.prodCrudData);
						props.setSession({
							isOnboardingEmp: result.data.data.companyDetails.isOnboardingEmp
						});
						if(!props.session.viaOmni) {
							setTimeout(() => {
								props.clickTrack({li: 'dc_landing',ll: 'digital_catalog', userBasedCheck: true});
							}, 500);
						}
					} else {
						props.setLoggedUser(data.prodCrudData);
					}
				})
			} else {
				props.setLoggedUser(data.prodCrudData);
			}
			props.toggleTab({isToggleTab: true})
		}
		return({
			errors: {
				code: 0
			},
			results:{
				match: data.isSuccess,
				vCodeFailCnt: data.invalidCount
			}
		});
    }
    const onComplete = (status) => {
		if(status == 'fail'){
			setHeader({
				heading: 'Verification Unsuccessful',
				leftIcons: [],
				rightIcons: [{
					className: 'icon-HDRcross',
					onClick: e => {historyHandler.closeCurrent();}
				}],
				variant: 'secondary'
			});
		}else if(status == 'success'){
			let pushUrl = fromDiscount ? "/products/discount" :fromInventory?"/products/inventory": fromOrderListing ? "/order" : "/products"
			history.push(pushUrl);
		}
	}
	const OtpVerificationComp = (
		<OtpVerification
			className='verify-container'
			sendRequest={{url: sendOtpApi,method: 'GET',headers:headersData}}
			sendRequestType='GET'
			verifyRequest={{'url': verifyOtpApi}}
			onVerify={onVerify}
			onComplete={onComplete}
			onSend={onSend}
			canChangeInput={false}
			product={null}
			sendOnMount={false}
			otpKey='otpValue'
			otpFormatter={(val)=>{return val}}
			input={mobOrEmail}
			inputType={isEmail ? 'email' : 'mobile'}
			view={{
				icon: 'https://image1.jdomni.in/jdomni_email/014_SmsOtp.svg',
				text: `We have sent an OTP verification to this ${isEmail ? 'email' : 'number'}`,
				codeText: 'Enter Code',
				submitBtnText: '',
				showSubmit: false,
				correctionText: ''
			}}
			autoRead={false}
			failedCount={failedCount}
			failureView={{
				className: 'verify-failed'
			}}
		/>
	)
	if(!props.isMobile){
		return (
			<div
				className="verification-pg-b2b"
			>
				<div className="verification-title">
					{heading}
				</div>
				{OtpVerificationComp}
			</div>

		)
	}
	return (
		<SliderWrapper
            slider={
                {className: 'verification-pg-b2b'}
            }
            header={{...header}}
            onHidden={show => {
                onHidden();
			}}
			animateChildren={isMobile && !failedCount}
        >
			{OtpVerificationComp}
		</SliderWrapper>
	);
};

const mapStateToProps = state => {
	return {
		isMobile: state.deviceData.isMobile,
		session: state.session
	};
};

export default connect(mapStateToProps, {setSession, setLoggedUser, toggleTab, clickTrack})(VerifyUser);
